import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
export function ProductPresentation() {
  const benefits = ['Giochi di movimento coinvolgenti.', 'Percorsi psicomotori con spiegazioni chiare.', 'Attività pratiche per sviluppare coordinazione, forza e agilità.', 'Lezioni strutturate passo dopo passo.', 'Strumenti di valutazione pronti da utilizzare.'];
  return <section className="py-16 px-4 bg-white" data-id="element-154">
      <div className="max-w-4xl mx-auto" data-id="element-155">
        <div className="text-center mb-12" data-id="element-156">
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6" data-id="element-157">
            Ed è proprio per questo che abbiamo creato il Mega-Pack Educazione
            Fisica.
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-158">
            Una raccolta completa di materiali progettati per aiutarti a
            organizzare le lezioni in modo semplice, rapido ed efficace.
          </p>
        </div>

        <div className="bg-gradient-to-br from-blue-50 to-green-50 rounded-3xl p-8 md:p-12 shadow-sm border border-blue-100" data-id="element-159">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-160">
            Con questo pacchetto avrai a disposizione centinaia di risorse:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-161">
            {benefits.map((benefit, idx) => <div key={idx} className="flex items-center gap-3 bg-white p-4 rounded-xl shadow-sm" data-id="element-162">
                <CheckCircle2Icon className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-163" />
                <span className="text-gray-800 font-medium" data-id="element-164">{benefit}</span>
              </div>)}
          </div>
          <p className="text-center text-gray-600 mt-8 italic" data-id="element-165">
            Tutto organizzato in modo chiaro, così potrai trovare rapidamente
            ciò di cui hai bisogno.
          </p>
        </div>
      </div>
    </section>;
}